import { render } from "./3Promo.vue?vue&type=template&id=1df39bde&scoped=true"
import script from "./3Promo.vue?vue&type=script&lang=js"
export * from "./3Promo.vue?vue&type=script&lang=js"

import "./3Promo.vue?vue&type=style&index=0&id=1df39bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df39bde"]])

export default __exports__